import * as THEOS from "../interfaces/theos.interface";
import { LogLevel, log } from "../utils/log";
import { IPostMessageApi } from "../interfaces/postMessageApi.interface";
import { _configuration } from "../feim/configuration";
import { handleRcChoice } from "./handleRcChoice";
import { postToOperator } from "../feim/postToOperator";
import { triggerEventInGame } from "../feim/registerEventHandler";
import { version } from "../../package.json";

/**
 * Theos API. Handshake and handling any configuration Theos layer sends.
 * FEIM uses Theos API event names and payloads internally so messages pass through unchanged.
 */

export class TheosApi implements IPostMessageApi
{
    public name = "Theos API";

    public constructor ()
    {
        log("Starting Theos handshake ...", LogLevel.INIT);
        postToOperator(this.processOutbound(THEOS.GameEvent.LISTENING));
    }

    public checkHandshake (data: unknown): boolean
    {
        const message = data as {feimOpEvent: string; payload?: unknown};

        if (message.feimOpEvent === THEOS.OperatorEvent.LISTENING) {
            log("... saying hello ...", LogLevel.INIT);
            const helloData: THEOS.IFeimHelloData = { feimVersion: version };
            postToOperator(this.processOutbound(THEOS.GameEvent.HELLO, helloData));

            // Handle the /rcchoice/ reality check used by some operators
            handleRcChoice(_configuration);
        }
        else if (message.feimOpEvent === THEOS.OperatorEvent.HELLO) {
            const payload = message.payload as THEOS.ITheosHelloData;

            log("... THEOS handshake complete", LogLevel.INIT);

            if (payload.handlesErrors) {
                log("Error messages are handled by the operator", LogLevel.INIT);
                _configuration.operatorHandlesErrors = true;
            }
            if (payload.handlesExit) {
                log("Game exiting is handled by the operator", LogLevel.INIT);
                _configuration.operatorHandlesGameExit = true;
            }

            triggerEventInGame(THEOS.OperatorEvent._INITIALIZED);

            return true;
        }

        return false;
    }

    public processInbound (data: {readonly [key: string]: unknown}): {feimOpEvent: THEOS.OperatorEvent; payload?: {}} | undefined
    {
        if (data.feimOpEvent !== undefined) {
            return data as {feimOpEvent: THEOS.OperatorEvent; payload: {}};
        }

        return undefined;
    }

    public processOutbound (event: THEOS.GameEvent, payload?: unknown): { [index: string]: unknown }
    {
        const processed: {feimGameEvent: string; payload?: unknown} = {feimGameEvent: event};

        if (payload !== undefined) {
            processed.payload = payload;
        }

        return processed;
    }
}
